<template>
  <div id="app">
    <router-view/>
    <material-selector v-if="showMaterialSelector"
      :type="materialType"
      :visible="showMaterialSelector"
      :limit="limit"
      :accept="accept"
      @close="showMaterialSelector = false"
      @confirm-select="handleConfirmSelect">
    </material-selector>
  </div>
</template>

<script>
import MaterialSelector from '@/components/material-selector/MaterialSelector.vue'
import Vue from 'vue';

export default {
  components: {
    MaterialSelector
  },
  name: 'app',
  data() {
    return {
      showMaterialSelector: false,
      limit: 9,
      materialType: 'picture',
      accept: ['jpg', 'jpeg', 'png', 'gif'],
    }
  },
  methods: {

    handleConfirmSelect() {

    },
    openMaterialLib(callback, limit, type = 'picture') {
      if (type === 'picture') {
        this.materialType = 'picture'
        this.accept = ['jpg', 'jpeg', 'png', 'gif']
      }
      if (type === 'video') {
        this.materialType = 'video'
        this.accept = ['mp4','mov','avi','3pg','rmvb','flv']
      }
      this.showMaterialSelector = true;
      if (limit) {
        this.limit = limit;
      } else {
        this.limit = 9;
      }
      this.handleConfirmSelect = (list) => {
        this.showMaterialSelector = false;
        if (typeof callback === 'function') {
          callback(list);
        }
      };
    }
  },
  beforeMount() {
    Vue.prototype.$openMaterialLib = this.openMaterialLib;
  },
  mounted() {
    window.onbeforeunload = () => {
      const path = this.$route.path;
      if (path && (path.includes('add') || path.includes('edit'))) {
        return true;
      } else {
        window.onbeforeunload = null;
      }
    };
  },
}
</script>
<style lang="scss">
  #app {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  body {
    // 270(left-menu width) + 500(main-menu minWidth) = 770px
    min-width: 770px;
    overflow-y: hidden;
  }
  // 解决字段填充满dialog但是仍会出现scrollbar的问题（默认的max-height=400）
  .el-dialog__body{
    padding: 10px 20px 0px;
    .avue-crud__dialog {
      max-height: 600px;
      .avue-form > .el-form > .el-row > .el-col {
        display: none;
      }
    }
  } 
  
  .el-dialog[aria-label="多 选"] {
    width: 70%;
  }
</style>
